import { render, staticRenderFns } from "./fullPreview.vue?vue&type=template&id=5c4a9b90"
import script from "./fullPreview.vue?vue&type=script&lang=js"
export * from "./fullPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports